import axios from 'axios';
import { Auth } from 'aws-amplify';

// Same axios client shape as the other services (picksApi / accountApi).
// Kept as its own instance so timeouts / retries don't cross-pollinate.
const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ??
  (process.env.NODE_ENV === 'production' ? '' : 'http://localhost:4001');

const client = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10_000,
});

client.interceptors.request.use(async (config) => {
  try {
    const session = await Auth.currentSession();
    const token = session.getIdToken().getJwtToken();
    config.headers = config.headers ?? {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (config.headers as any).Authorization = `Bearer ${token}`;
  } catch {
    // No active session — request goes unauthenticated, server replies 401.
  }
  return config;
});

export type ContactInput = {
  firstname: string;
  email: string;
  message: string;
  rating?: number;
};

export type ContactSubmitResponse = {
  status: 'sent' | 'skipped';
  messageId?: string;
  reason?: string;
};

export const submitContact = async (input: ContactInput): Promise<ContactSubmitResponse> => {
  const res = await client.post<ContactSubmitResponse>('/api/v1/contact', input);
  return res.data;
};
